export const CONTACT_EMAIL = 'adam@adamnuccio.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
